import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { type Form, nameModelSortFn, type Stored } from "@overmap-ai/common"
import { useSort, useTextFilter } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import { formFilterCallback } from "../../filtering/utils"
import { modelIconMapping } from "../../mappings/icons"
import { FormSelectGroup, type FormSelectGroupProps } from "../MenuSelectGroups/FormSelectGroup"

type FormDropdownSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	FormSelectGroupProps & {
		children: ReactElement
	}

export const FormDropdownSelect = memo<FormDropdownSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,
		// FormSelectGroup props
		forms,
		required,
		defaultValue,
		value,
		onValueChange,
		...rest
	} = props

	const sortedForms = useSort(forms, nameModelSortFn)

	const [filteredForms, filterValue, setFilterValue] = useTextFilter<Stored<Form>>(sortedForms, formFilterCallback)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				<Menu.InputRoot>
					<Menu.InputSlot>
						<LuIcon icon={modelIconMapping.search} />
					</Menu.InputSlot>
					<Menu.InputField placeholder="Search" value={filterValue} onValueChange={setFilterValue} />
				</Menu.InputRoot>
				{filteredForms.length > 0 && <Menu.Separator />}
				<Menu.Scroll>
					{/** TODO: Find away for the type discriminate to work without doing a explicit type check on required */}
					{required ? (
						<FormSelectGroup
							required={required}
							defaultValue={defaultValue}
							value={value}
							onValueChange={onValueChange}
							forms={filteredForms}
						/>
					) : (
						<FormSelectGroup
							required={required}
							defaultValue={defaultValue}
							value={value}
							onValueChange={onValueChange}
							forms={filteredForms}
						/>
					)}
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
FormDropdownSelect.displayName = "FormDropdownSelect"
